import React from 'react';
import { lifestyleBenefits } from '../../data/presellContent';
export function LifestyleBenefits() {
  return <section id="benefits" className="w-full bg-white" data-id="element-42" data-mp="2r2hlhft3yewp">
      <div className="max-w-6xl mx-auto px-5 md:px-8 py-14 md:py-20" data-id="element-43" data-mp="2vu9dlurwwsoy">
        <h2 className="text-2xl md:text-4xl font-bold text-[#22322C] leading-snug text-center max-w-3xl mx-auto" data-id="element-44" data-mp="2vv19l6pf8sfr">
          What Better Joint Support Could Mean For Everyday Life
        </h2>

        <ul className="mt-10 md:mt-14 grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-45" data-mp="23754pepp7u7w">
          {lifestyleBenefits.map(({
          id,
          title,
          description,
          image,
          imageAlt
        }) => <li key={id} className="flex flex-col" data-id="element-46" data-mp="2d2ovxntbi4qb">
                <img src={image} alt={imageAlt} className="w-full h-[220px] md:h-[260px] object-cover rounded-2xl" loading="lazy" data-id="element-47" data-mp="2h5d7425i7nqg" />
                <h3 className="mt-5 text-xl font-semibold text-[#22322C] leading-snug" data-id="element-48" data-mp="3sjz4cox68qcx">
                  {title}
                </h3>
                <p className="mt-2 text-[#5A6D60] leading-relaxed" data-id="element-49" data-mp="d4qvhevau6hf">
                  {description}
                </p>
              </li>)}
        </ul>

        <p className="mt-12 text-lg text-[#4A5D50] leading-relaxed text-center max-w-2xl mx-auto" data-id="element-50" data-mp="36bew5twefm6">
          For many people, better support can mean doing more of what they enjoy
          with greater ease and confidence.
        </p>
      </div>
    </section>;
}